import _ from 'lodash';

import React, { Component } from 'react';
import PropTypes from 'prop-types';

import {
  TextField, Checkbox, FormControlLabel, Radio,
} from '@mui/material';

import { openQuestionAnswerShape, openQuestionShape } from '../../types';

class TrialOpenQuestion extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  setAnswerSingle = (id) => {
    const newAnswers = [{
      answer: id,
      detailQuestionAnswer: '',
    }];

    this.props.onChange(newAnswers);
  };

  setAnswerMultiple(id, value) {
    const newAnswers = _.clone(this.props.answers);

    if (value) {
      const existingIndex = _.findIndex(newAnswers, (answer) => answer.answer === id);

      // should never be not equal, but just in case.
      if (existingIndex === -1) {
        newAnswers.push({ answer: id, detailQuestionAnswer: '' });
      }
    } else {
      _.remove(newAnswers, (answer) => answer.answer === id);
    }

    this.props.onChange(newAnswers);
  }

  setDetailQuestionAnswer = (id, value) => {
    let newAnswers;

    const questionType = this.props.question.type.toLowerCase();
    if (questionType === 'single') {
      newAnswers = [{
        answer: this.props.answers[0].answer,
        detailQuestionAnswer: value,
      }];
    } else if (questionType === 'multiplechoice' || questionType === 'multiple') {
      newAnswers = _.clone(this.props.answers);
      const existingIndex = _.findIndex(newAnswers, (answer) => answer.answer === id);

      // should never not exist, but just in case.
      if (existingIndex !== -1) {
        newAnswers[existingIndex].detailQuestionAnswer = value;
      }
    }

    this.props.onChange(newAnswers);
  };

  setFreeTextAnswer = (id, value) => {
    this.props.onChange([{
      answer: value,
    }]);
  };

  detailQuestionValue = (id) => {
    const value = this.props.answers
      .find((answer) => answer.answer === id);
    return value ? value.detailQuestionAnswer : '';
  };

  isInputMissing = (question) => {
    if (question.type === 'freeText') {
      const currentInput = this.state[`freeText_${this.props.question.uuid}`] || (this.props.answers && this.props.answers.answer);
      return question.required && !currentInput;
    }
    return question.required
      && question.options.every((option) => !this.checked(option.answer.uuid));
  };

  checked(id) {
    return _.find(
      this.props.answers,
      (answer) => answer.answer === id,
    ) !== undefined;
  }

  showDetailQuestionTextField(option) {
    return option.detailQuestion && _
      .some(this.props.answers, (answer) => answer.answer === option.answer.uuid);
  }

  renderOptionSingle(option) {
    return (
      <FormControlLabel
        id={option.answer.highlight ? `highlight-${option.answer.uuid}` : undefined}
        control={(
          <Radio
            onChange={(e) => this.setAnswerSingle(option.answer.uuid, e.target.checked)}
            checked={this.checked(option.answer.uuid)}
            disabled={this.props.disabled}
          />
        )}
        label={option.answer.text}
      />
    );
  }

  renderOptionMultiple(option) {
    const isChecked = this.checked(option.answer.uuid);
    return (
      <FormControlLabel
        id={option.answer.highlight ? `highlight-${option.answer.uuid}` : undefined}
        control={(
          <Checkbox
            onChange={(e) => this.setAnswerMultiple(option.answer.uuid, e.target.checked)}
            checked={isChecked}
            disabled={this.props.disabled}
          />
        )}
        label={option.answer.text}
      />
    );
  }

  renderFreeText = (inputIsMissing, { hideTextFieldPlaceholder, freeTextPlaceholder }) => {
    const answerFromState = this.state[`freeText_${this.props.question.uuid}`];
    const answerFromProps = this.props.answers && this.props.answers.answer;
    const freeTextValue = (answerFromState === undefined) ? answerFromProps : answerFromState;
    return (
      <div>
        <TextField
          id={`OpenQuestionFreeTextField-${this.props.question.uuid}`}
          multiline
          className="w-100"
          rows={2}
          value={freeTextValue || ''}
          onChange={(e) => this.setState({ [`freeText_${this.props.question.uuid}`]: e.target.value })}
          onBlur={(e) => this.props.onChange({
            answer: e.target.value,
          })}
          error={inputIsMissing}
          placeholder={!hideTextFieldPlaceholder ? freeTextPlaceholder : ''}
          disabled={this.props.disabled}
          variant="standard"
        />
      </div>
    );
  };

  renderSingleOrMultiple = (option) => (
    <div>
      {
        this.props.question.type === 'single'
          ? this.renderOptionSingle(option)
          : this.renderOptionMultiple(option)
      }
      {
        this.showDetailQuestionTextField(option) && (
          <div className="pl4 pt3 flex flex-column">
            <span className="fw4 color-quip">{option.detailQuestion.text}</span>
            <TextField
              id={`DetailQuestionTextField-${option.detailQuestion.uuid}`}
              multiline
              rows={2}
              style={{ width: 400 }}
              value={this.state[`detail_${option.answer.uuid}`] || this.detailQuestionValue(option.answer.uuid)}
              onChange={(e) => this.setState({ [`detail_${option.answer.uuid}`]: e.target.value })}
              onBlur={(e) => this.setDetailQuestionAnswer(
                option.answer.uuid,
                e.target.value,
              )}
              disabled={this.props.disabled}
              variant="standard"
            />
          </div>
        )
      }
    </div>
  );

  renderOption(option, params) {
    return (
      <div key={option.answer.uuid}>
        {this.renderSingleOrMultiple(option, params)}
      </div>
    );
  }

  render() {
    const { question } = this.props;
    const inputIsMissing = this.isInputMissing(question);
    return (
      <>
        <div id={question.question.highlight ? `highlight-${question.question.uuid}` : undefined} className={`f4 bg-near-white pb2 pt2 pl2 mb0 ${inputIsMissing && 'red bold'}`}>
          {`${question.question.text} `}
        </div>
        <div className="pa2">
          {
            question.type === 'freeText'
              ? this.renderFreeText(inputIsMissing, question)
              : _.map(question.options, (option) => this.renderOption(option, question))
          }
        </div>
      </>
    );
  }
}

TrialOpenQuestion.propTypes = {
  question: openQuestionShape,
  answers: PropTypes.oneOfType([
    PropTypes.arrayOf(openQuestionAnswerShape),
    PropTypes.shape({
      answer: PropTypes.string,
    }),
  ]),
  onChange: PropTypes.func,
  disabled: PropTypes.bool,
};

TrialOpenQuestion.defaultProps = {
  question: undefined,
  answers: [],
  onChange: undefined,
  disabled: false,
};

export default TrialOpenQuestion;
